import { render, staticRenderFns } from "./VTaskList.vue?vue&type=template&id=263d2a1a&scoped=true"
import script from "./VTaskList.vue?vue&type=script&lang=js"
export * from "./VTaskList.vue?vue&type=script&lang=js"
import style0 from "./VTaskList.vue?vue&type=style&index=0&id=263d2a1a&prod&lang=css"
import style1 from "./VTaskList.vue?vue&type=style&index=1&id=263d2a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263d2a1a",
  null
  
)

export default component.exports